import { Col, Form, Input, Pagination, Row, Table, Typography } from 'antd';
import React from 'react';

import './styles.css';

class TableComponent extends React.Component {
  render = () => {
    const {
      _expandedRows,
      _columns,
      _data,
      _onChangeTable,
      _onSend,
      _loading,
      _onChangePagination,
      _pagination,
      _onChangeSearch,
      _search,
      _rowSelection,
      _align,
    } = this.props;

    return (
      <Row className="table__row_table" gutter={[8, 8]}>
        <Col span={24}>
          <Row>
            <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography className="table__summary">
                Total de {_pagination.total} registros retornados
              </Typography>
            </Col>
            <Col span={12}>
              <Form
                className="table__form_filter"
                layout="vertical"
                onFieldsChange={_onSend}
              >
                <Form.Item name="search">
                  <Input
                    className="table__form_filter_input"
                    id="PESQUISA"
                    onChange={_onChangeSearch}
                    placeholder={'Pesquisar...'}
                    value={_search}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Table
            className={`table__ ${_align}`}
            columns={_columns}
            dataSource={_data}
            expandable={_expandedRows}
            loading={_loading}
            onChange={_onChangeTable}
            pagination={false}
            rowSelection={
              _rowSelection ? { type: 'checkbox', ..._rowSelection } : null
            }
            scroll={{ x: true }}
            size="small"
          />
        </Col>
        {_pagination?.current > 0 ? (
          <Col span={24}>
            <Row justify="end">
              <Pagination
                current={_pagination.current}
                defaultCurrent={_pagination.current}
                onChange={_onChangePagination}
                showSizeChanger
                size="small"
                total={_pagination.total}
              />
            </Row>
          </Col>
        ) : null}
      </Row>
    );
  };
}

export default TableComponent;
